import React, { FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";

import { ContactForm } from "../../interfaces/contact_form";
import { submitContactForm } from "../../services/web3forms";
import { ContactUsForm } from "../ContactUsForm";
import Modal from "../Modal";

interface Props {
  useModal: any;
}

const initForm: ContactForm = {
  firstName: "",
  lastName: "",
  email: "",
  message: "",
  contactReason: "3",
  botcheck: false,
  agreement: false,
  lang: "en",
  phoneNumber: ""
};

// The free report is only available in English
const freeReportUrl = "/docs/Seven-Little-Known-Ways-To-Skyrocket-Your-Production-By-135-Percent.pdf";

const SendReportPopup: React.FC<Props> = ({ useModal, ...rest }) => {
  const { i18n } = useTranslation();
  const [form, setForm] = useState<ContactForm>(initForm);
  const [hasError, setHasError] = useState<boolean>(false);
  const [successful, setSuccessful] = useState<boolean>(false);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    form.lang = i18n.language;

    submitContactForm(form, "Free report request — triangular-pod.com")
      .then(() => {
        setHasError(false);
        setSuccessful(true);
      })
      .then(() => setForm(initForm))
      .catch(() => {
        setSuccessful(false);
        setHasError(true);
      });
  };

  const status = { error: hasError, success: successful };

  return (
    <Modal usedModal={useModal} height="95%" overflowY="auto" maxHeight="95vh" {...rest}>
      <ContactUsForm
        form={form}
        setForm={setForm}
        handleSubmit={handleSubmit}
        status={status}
        freeReport={true}
        freeReportUrl={freeReportUrl}
      />
    </Modal>
  );
};

export default SendReportPopup;
